import axios from 'axios';
import { CommonService } from './common.services';
export class MeetingService extends CommonService {
    async findByContext(context) {
        try {
            const response = await axios.get(this.getServerUrl() + '/meetings/findByContext?context=' + context, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async findDashboarBy(evento, hash) {
        try {
            const response = await axios.get(this.getServerUrl() + '/meetings/findDashboardBy?evento=' + evento + '&hash=' + hash, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async findAcreditadoMeetingBy(evento, hash) {
        try {
            const response = await axios.get(this.getServerUrl() + '/meetings/findAcreditadoMeetingBy?evento=' + evento + '&hash=' + hash, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async findEmpresaAcreditadoBy(evento, hash) {
        try {
            const response = await axios.get(this.getServerUrl() + '/meetings/findEmpresaAcreditadoBy?evento=' + evento + '&hash=' + hash, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async saveEmpresa(evento, hash, empresa) {
        try {
            const response = await axios.post(super.getServerUrl() + '/meetings/saveEmpresa?evento=' + evento + '&hash=' + hash, empresa, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return (response.data == "OK");
        }
        catch (error) {
            throw super.manageError(error);
        }
    }
    async updateEmpresa(evento, hash, empresa) {
        try {
            const response = await axios.post(super.getServerUrl() + '/meetings/updateEmpresa?evento=' + evento + '&hash=' + hash, empresa, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return (response.data == "OK");
        }
        catch (error) {
            throw super.manageError(error);
        }
    }
    async findTiposAcreditadosSolicitablesBy(evento) {
        try {
            const response = await axios.get(this.getServerUrl() + '/meetings/findTiposAcreditadosSolicitablesBy?evento=' + evento, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async findTiposAcreditadosSolicitantesBy(evento) {
        try {
            const response = await axios.get(this.getServerUrl() + '/meetings/findTiposAcreditadosSolicitantesBy?evento=' + evento, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async findItemsMeetingBy(evento, hash) {
        try {
            const response = await axios.get(this.getServerUrl() + '/meetings/findItemsMeetingBy?evento=' + evento + '&hash=' + hash, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async findCitasDisponiblesBy(evento, hash, fecha, itemMeeting) {
        try {
            fecha = encodeURIComponent(fecha);
            const item = { "itemMeeting": itemMeeting };
            const response = await axios.post(this.getServerUrl() + '/meetings/findCitasDisponiblesBy?evento=' + evento + '&hash=' + hash + '&fecha=' + fecha, item, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async findCitasDisponiblesFechaBy(evento, hash, fecha) {
        try {
            fecha = encodeURIComponent(fecha);
            const response = await axios.get(this.getServerUrl() + '/meetings/findCitasDisponiblesFechaBy?evento=' + evento + '&hash=' + hash + '&fecha=' + fecha, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async reservarCita(evento, hash, idCronograma, idAcreditadoSolicitado, observaciones) {
        try {
            const response = await axios.post(this.getServerUrl() + '/meetings/reservarCita?evento=' + evento + '&cronograma=' + idCronograma + '&acreditadoSolicitado=' + idAcreditadoSolicitado + '&hash=' + hash, observaciones, { headers: { "Authorization": this.token, "Client-ID": this.clientId, "Content-Type": "text/plain" } });
            return (response.data == "OK");
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async findFechasBy(evento) {
        try {
            const response = await axios.get(this.getServerUrl() + '/meetings/findFechasBy?evento=' + evento, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async findDetalleAgendaBy(evento, hash, tipo) {
        try {
            const response = await axios.get(this.getServerUrl() + '/meetings/findDetalleAgendaBy?evento=' + evento + '&hash=' + hash + '&tipo=' + tipo, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async findDetalleAgendaFechaBy(evento, hash, tipo, fecha) {
        try {
            fecha = encodeURIComponent(fecha);
            const response = await axios.get(this.getServerUrl() + '/meetings/findDetalleAgendaBy?evento=' + evento + '&hash=' + hash + '&tipo=' + tipo + '&fecha=' + fecha, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async bloquear(evento, hash, idCronograma, observaciones) {
        try {
            observaciones = encodeURIComponent(observaciones);
            const response = await axios.get(this.getServerUrl() + '/meetings/bloquear?evento=' + evento + '&cronograma=' + idCronograma + '&observaciones=' + observaciones + '&hash=' + hash, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return (response.data == "OK");
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async bloquearDiaCompleto(evento, hash, fecha) {
        try {
            fecha = encodeURIComponent(fecha);
            const response = await axios.get(this.getServerUrl() + '/meetings/bloquearDiaCompleto?evento=' + evento + '&fecha=' + fecha + '&hash=' + hash, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return (response.data == "OK");
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async desbloquear(evento, hash, idAgenda) {
        try {
            const response = await axios.get(this.getServerUrl() + '/meetings/desbloquear?evento=' + evento + '&agenda=' + idAgenda + '&hash=' + hash, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return (response.data == "OK");
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async cancelar(evento, hash, idAgenda) {
        try {
            const response = await axios.get(this.getServerUrl() + '/meetings/cancelar?evento=' + evento + '&agenda=' + idAgenda + '&hash=' + hash, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return (response.data == "OK");
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async cambiarEstado(evento, hash, idAgenda, idEstado, observaciones) {
        try {
            observaciones = encodeURIComponent(observaciones);
            const response = await axios.post(this.getServerUrl() + '/meetings/cambiarEstadoCita?evento=' + evento + '&agenda=' + idAgenda + '&idEstado=' + idEstado + '&hash=' + hash, observaciones, { headers: { "Authorization": this.token, "Client-ID": this.clientId, "Content-Type": "text/plain" } });
            return (response.data == "OK");
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async findMensajesBy(evento, hash) {
        try {
            const response = await axios.get(this.getServerUrl() + '/meetings/findMensajesBy?evento=' + evento + '&hash=' + hash, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async findConversacionBy(evento, hash, idAcreditadoConversacion) {
        try {
            const response = await axios.get(this.getServerUrl() + '/meetings/findConversacionBy?evento=' + evento + '&hash=' + hash + '&acreditado=' + idAcreditadoConversacion, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async responder(evento, hash, idAcreditadoPara, mensaje) {
        try {
            const response = await axios.post(this.getServerUrl() + '/meetings/responder?evento=' + evento + '&hash=' + hash + '&acreditado=' + idAcreditadoPara, mensaje, { headers: { "Authorization": this.token, "Client-ID": this.clientId, "Content-Type": "text/plain" } });
            return (response.data == "OK");
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async sendInvitacionMeeting(evento, hash, empresa, mail) {
        try {
            const response = await axios.get(this.getServerUrl() + '/meetings/sendInvitacionMeeting?evento=' + evento + '&hash=' + hash + '&empresa=' + empresa + '&mail=' + mail, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return (response.data == "OK");
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async downloadAgendaPdf(evento, hash, lang) {
        try {
            const response = await axios.get(this.getServerUrl() + `/meetings/getAgendaPdf?evento=${evento}&hash=${hash}&lang=${lang}`, { responseType: 'blob', headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            const blob = new Blob([response.data], { type: 'application/pdf' });
            let filename = 'agenda.pdf';
            const contentDisposition = response.headers['content-disposition'];
            if (contentDisposition) {
                const match = contentDisposition.match(/filename="?(.+)"?/);
                if (match)
                    filename = match[1];
            }
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            a.click();
            window.URL.revokeObjectURL(url);
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
}
